import type { WorkStatus } from "../types/domain";

export interface StatusDefinition {
  label: string;
  shortLabel: string;
  description: string;
  factor: number;
  tone: "neutral" | "info" | "active" | "warning" | "success" | "danger";
}

export const statusDefinitions: Record<WorkStatus, StatusDefinition> = {
  pending: {
    label: "Pendiente",
    shortLabel: "Pendiente",
    description: "Existe en el roadmap conocido, pero todavía no está planificado.",
    factor: 0,
    tone: "neutral",
  },
  planned: {
    label: "Planificado",
    shortLabel: "Planificado",
    description: "Alcance conocido y ordenado, todavía sin implementación activa.",
    factor: 0.1,
    tone: "info",
  },
  in_development: {
    label: "En desarrollo",
    shortLabel: "Desarrollo",
    description: "Implementación activa en una rama o bloque de trabajo.",
    factor: 0.5,
    tone: "active",
  },
  in_verification: {
    label: "En verificación",
    shortLabel: "Verificación",
    description: "Implementado y bajo pruebas, revisión o CI.",
    factor: 0.75,
    tone: "warning",
  },
  in_manual_acceptance: {
    label: "En aceptación manual",
    shortLabel: "Aceptación",
    description: "Las puertas automáticas pasaron y falta validar el comportamiento real.",
    factor: 0.9,
    tone: "warning",
  },
  accepted: {
    label: "Aceptado",
    shortLabel: "Aceptado",
    description: "Puertas acordadas superadas y resultado aceptado.",
    factor: 1,
    tone: "success",
  },
  blocked: {
    label: "Bloqueado",
    shortLabel: "Bloqueado",
    description:
      "El trabajo comenzó, pero existe una dependencia o incidente que impide continuar.",
    factor: 0.35,
    tone: "danger",
  },
  deferred: {
    label: "Diferido",
    shortLabel: "Diferido",
    description: "Pertenece a la visión, pero se aplaza deliberadamente.",
    factor: 0,
    tone: "neutral",
  },
  out_of_scope: {
    label: "Fuera de alcance",
    shortLabel: "Fuera",
    description: "No forma parte del alcance actual y se excluye del denominador de progreso.",
    factor: 0,
    tone: "neutral",
  },
};

export const orderedStatuses: WorkStatus[] = [
  "in_development",
  "in_verification",
  "in_manual_acceptance",
  "blocked",
  "planned",
  "pending",
  "accepted",
  "deferred",
  "out_of_scope",
];
